import script from "./Add.vue?vue&type=script&setup=true&lang=js"
export * from "./Add.vue?vue&type=script&setup=true&lang=js"

import "./Add.vue?vue&type=style&index=0&id=b1b5614c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1b5614c"]])

export default __exports__